import React from 'react';

export default function ErrorListTemplate(props) {
  const {errors} = props;
  
  return (
    <div className="ui error message">
      <ul className="list">
        {errors.map((error, i) => {
          return (
            <li key={i}>
              {error.stack}
            </li>
          );
        })}
      </ul>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ui/semantic-form/error-list-template.js